<template>
    <!-- 팝업 -->
    <div class="pop_up_layer" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail preview" style="display: block; height: 80%">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <div class="sub_page" :class="[state.type !== 'news' ? '_activity' : '_news']" style="max-height: 100%; overflow-y: auto">
            <section class="sub_page_tit">
                <div class="banner_wrap wrap_1120">
                    <h2>소개</h2>
                </div>

                <div class="sub_menu_tab wrap_1120" v-html="state.header"></div>
            </section>
            <section class="sub_page_con wrap_1120">
                <div class="bread_crumbs">
                    <a href="" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></a>
                    <span class="icon_wrap"><img src="img/part_icon.png" alt="시민참여 활동" /></span>
                    <a href="">시민참여 활동</a>
                    <span class="icon_wrap"><img src="img/part_icon.png" alt="반성매매 시민활동" /></span>
                    <a href="">반성매매 시민활동</a>
                    <span class="icon_wrap"><img src="img/part_icon.png" :alt="state.title" /></span>
                    <span class="faq_title">{{ state.title }}</span>
                </div>
                <div class="sub_page_con_view con_view">
                    <div class="tit_wrap flex_wrap">
                        <span class="con_tit">{{ state.title }}</span>
                        <div class="con_tit_info">
                            <span class="">{{ CommonUtils.dateFormat(new Date(), ".", true) }}</span>
                            <span class="">
                                <span><img src="img/view.png" alt="" /></span>
                                0
                            </span>
                            <span class="writer_info">
                                <span>작성자</span>
                                {{ user.userInfo.name }}
                            </span>
                        </div>
                    </div>
                    <div class="con_info_wrap" v-if="state.type !== 'news'">
                        <div v-if="state.data.activityStartDate && state.data.activityEndDate">
                            <span class="info_tit">
                                <img src="img/info_icon_01.png" alt="활동기간" />
                                활동기간
                            </span>
                            <span class="info_desc">
                                {{
                                    CommonUtils.dateFormat(new Date(state.data.activityStartDate), ".", false) +
                                    "-" +
                                    CommonUtils.dateFormat(new Date(state.data.activityEndDate), ".", false)
                                }}
                            </span>
                        </div>
                        <div v-if="state.data.recruitmentStartDate && state.data.recruitmentEndDate">
                            <span class="info_tit">
                                <img src="img/info_icon_02.png" alt="모집기간" />
                                모집기간
                            </span>
                            <span class="info_desc">
                                {{
                                    CommonUtils.dateFormat(new Date(state.data.recruitmentStartDate), ".", false) +
                                    "-" +
                                    CommonUtils.dateFormat(new Date(state.data.recruitmentEndDate), ".", false)
                                }}
                            </span>
                        </div>
                        <div v-if="state.data.endDate">
                            <span class="info_tit">
                                <img src="img/info_icon_02.png" alt="신청 마감" />
                                신청 마감
                            </span>
                            <span class="info_desc">
                                {{ CommonUtils.dateFormat(new Date(state.data.endDate), ".", false) }}
                            </span>
                        </div>
                        <div v-if="state.data.cntMember > 0">
                            <span class="info_tit">
                                <img src="img/info_icon_03.png" alt="모집인원" />
                                모집인원
                            </span>
                            <span class="info_desc">{{ state.data.cntMember }}명</span>
                        </div>
                        <div v-if="state.data.address">
                            <span class="info_tit">
                                <img src="img/info_icon_04.png" alt="장소" />
                                장소
                            </span>
                            <span class="info_desc">{{ state.data.address }} {{ state.data.addressDetail }}</span>
                        </div>
                    </div>
                    <div class="content_wrap" v-html="state.content"></div>

                    <div class="btn_wrap _default right_btn _board_type">
                        <button class="common_btn" type="button">목록</button>
                    </div>
                </div>

                <!-- <div class="list_wrap">
                    <a href="javascript:void(0)" class="next_list">
                        <span>다음글</span>
                        <div class="list_tit elips_1">다음글 ...</div>
                        <div class="list_date">{{ CommonUtils.dateFormat(new Date(), ".", false) }}</div>
                    </a>

                    <a href="javascript:void(0)" class="prev_list">
                        <span>이전글</span>
                        <div class="list_tit elips_1">이전글 ...</div>
                        <div class="list_date">{{ CommonUtils.dateFormat(new Date(), ".", false) }}</div>
                    </a>
                </div> -->
            </section>
        </div>
    </div>
    <!-- 팝업 -->
</template>
<script lang="ts" config>
    import { reactive, router, apiService, onMounted, onUnmounted, watch, computed, CommonUtils, ref, userStore } from "@/BaseComponent";

    export default {
        props: {
            type: {
                type: String,
                default: "",
            },
            header: {
                type: Object,
                default: "",
            },
            title: {
                type: String,
                default: "",
            },

            content: {
                type: String,
                default: "",
            },
            data: {
                type: Object,
                default: {},
            },
        },
        emits: ["close"],
        components: {},
        setup(props: any, { emit }: any) {
            const user = userStore();
            const state = reactive({
                type: "" as string,
                title: "" as string,
                content: "" as string,
                header: "" as string,
                data: {} as any,
            });

            onMounted(() => {
                state.type = props.type;
                state.title = props.title;
                state.content = props.content;
                state.header = props.header;
                state.data = props.data;

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.type = props.type;
                state.title = props.title;
                state.content = props.content;
                state.header = props.header;
                state.data = props.data;
            });

            const closeModal = () => {
                emit("close");
            };

            return { state, closeModal, CommonUtils, user };
        },
    };
</script>

<style scoped>
    .textarea {
        width: 100%;
    }

    .pop_up.preview {
        width: 100%;
        max-width: 60%;
    }
    
    .list_wrap a[class*="_list"]:nth-child(2) {
        border-top: 1px solid #c4c4c4;
    }

    .list_wrap a[class*="_list"] {
        display: flex;
        gap: 10px;
        padding: 10px 0;
        position: relative;
        cursor: pointer;
    }

    .list_wrap a[class*="_list"]:hover {
        background-color: #fafafa;
    }

    .list_wrap a[class*="_list"] span {
        background-color: #fff9e9;
        padding: 3px 10px;
        color: #ff8935;
        font-weight: 500;
        font-size: 14px;
    }
</style>
